import url from './url';

export default class SearchForm {
    constructor(config) {
        this.config = config;
        this.mostRecentlyUsedForm = null;
    }

    reset() {
        this.mostRecentlyUsedForm = null;
    }

    getCurrentForm() {
        const searchForms = Array.prototype.slice
            .apply(document.querySelectorAll(this.config.searchFieldSelector))
            .map((searchField) => searchField.form);

        const activeForm = document.activeElement.form;
        if (activeForm && searchForms.indexOf(activeForm) > -1) {
            this.mostRecentlyUsedForm = activeForm;
            return activeForm;
        } else {
            // Order of preference: Most recently used search form > first search form > null.
            if (this.mostRecentlyUsedForm !== null) {
                return this.mostRecentlyUsedForm;
            } else if (searchForms.length > 0) {
                return searchForms[0];
            }

            return null;
        }
    }

    getAll() {
        const currentForm = this.getCurrentForm();
        return currentForm === null ? {} : url.parseQueryString(new URLSearchParams(new FormData(currentForm)).toString());
    }

    get(propertyPath) {
        let formParams = this.getAll();
        let value = null;
        let propertyPathParts = propertyPath.split('.');

        while (propertyPathParts.length > 0) {
            value = formParams = formParams[propertyPathParts[0]];
            propertyPathParts = propertyPathParts.slice(1);

            if (!value) {
                // Can't follow the property path any further - abort.
                break;
            }
        }

        return typeof value === 'undefined' ? null : value;
    }

    static getFocusedSearchField(fields) {
        // Try to get focused or visible search-field, otherwise use all found fields.
        return Array.prototype.slice.call(fields).indexOf(document.activeElement) !== -1 ? document.activeElement : fields;
    }
}
